<div *qmLoading="loading" class="d-flex flex-column w-100">
  <div *ngFor="let row of data;" class="d-flex flex-row">
    <qm-percentage-circle
      class="percentage-circle"
      [value]="row.value"
      [color]="row.color"
    >
      <div class="circle-label value">{{row.value}} %</div>
      <div class="circle-label name">{{row.shortLabel | translate}}</div>
      <div class="circle-label fraction">{{row.sum}} / {{row.count}}</div>
    </qm-percentage-circle>
    <div class="chart-container">
      <div class="chart-title">
        {{row.longLabel | translate}}
        <span class="chat-timespan">3h</span>
      </div>
      <ngx-charts-line-chart
        [view]="[graphWidth, graphHeight]"
        [scheme]="graphColors"
        schemeType="linear"
        [results]="row.results"
        [curve]="curveFunction"
        [yScaleMin]="0"
        [yScaleMax]="100"
        [animations]="false"
        [yAxis]="true"
        [yAxisTicks]="[0, 20, 40, 60, 80, 100]"
        [yAxisTickFormatting]="yAxisTickFormatting"
        [showRefLabels]="false"
      >
        <!-- based on default template in `@swimlane/ngx-charts/src/common/tooltip-area.component.ts` -->
        <ng-template #seriesTooltipTemplate let-model="model">
          <div class="area-tooltip-container">
            <div
              *ngFor="let item of model"
              class="tooltip-item"
            >
              {{item.value | number:'0.0-0'}}% <!-- drop decimals -->
              {{'at' | translate}}
              {{item.name}}
            </div>
          </div>
        </ng-template>
      </ngx-charts-line-chart>
    </div>
  </div>
</div>
